import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Inspection } from '../Models/Inspection';
import { InspectionAsset } from '../Models/InspectionAsset';
import { InspectionCustom } from '../Models/InspectionCustom';
import { BasicSearchRequest } from '../Models/BasicSearchRequest';

class InspectionApi {
  static getInspection(id: string) {
    return axios.get<Inspection>(
      `${API_URL}/api/inspection/${id}`,
      getAuthHeader()
    );
  }
  static getUserLatestInspection(id: number) {
    return axios.get<Inspection>(
      `${API_URL}/api/inspection/user/${id}/latest`,
      getAuthHeader()
    );
  }
  static getInspectionList() {
    return axios.get<Inspection[]>(
      `${API_URL}/api/inspection`,
      getAuthHeader()
    );
  }
  static getInspectionListCustom(request: BasicSearchRequest) {
    return axios.post<InspectionCustom[]>(
      `${API_URL}/api/inspection/list/custom`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateInspection(request: Inspection) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inspection`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateInspectionAsset(request: InspectionAsset) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inspection/asset`,
      request,
      getAuthHeader()
    );
  }
  static assignFormToInspectionAsset(
    inspectionAssetId: number,
    sopformId: number
  ) {
    return axios.put<ResponseModel>(
      `${API_URL}/api/inspection/asset/${inspectionAssetId}/form/${sopformId}`,
      null,
      getAuthHeader()
    );
  }
  static createPostInspection(inspectionId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inspection/${inspectionId}/createpostinspection`,
      null,
      getAuthHeader()
    );
  }
  static uploadSopFormImages(sopFormId: number, request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inspection/form/${sopFormId}/image/upload`,
      request,
      getAuthHeader()
    );
  }
}

export default InspectionApi;
